import { log } from '@guardian/libs';
import { recordAdmiralOphanEvent } from './admiral';
const handleMeasureDetectedEvent = (event) => {
    const isMeasureDetectedEvent = (e) => typeof e === 'object' &&
        'adblocking' in e &&
        'whitelisted' in e &&
        'subscribed' in e;
    if (isMeasureDetectedEvent(event)) {
        if (event.adblocking) {
            log('commercial', '🛡️ Admiral - user has an adblocker and it is enabled');
            recordAdmiralOphanEvent({ action: 'DETECT', value: 'blocked' });
        }
        if (event.whitelisted) {
            log('commercial', '🛡️ Admiral - user has seen Engage and subsequently disabled their adblocker');
            recordAdmiralOphanEvent({ action: 'DETECT', value: 'whitelisted' });
        }
        if (event.subscribed) {
            log('commercial', '🛡️ Admiral - user has an active subscription to a transact plan');
        }
    }
    else {
        log('commercial', `🛡️ Admiral - Event is not of expected format of measure.detected ${JSON.stringify(event)}`);
    }
};
const handleCandidateShownEvent = (event) => {
    const isCandidateShownEvent = (e) => typeof e === 'object' &&
        'candidateID' in e &&
        'variantID' in e &&
        'candidateGroups' in e;
    if (isCandidateShownEvent(event)) {
        log('commercial', `🛡️ Admiral - Launching candidate ${event.candidateID}`);
        recordAdmiralOphanEvent({ action: 'VIEW', value: event.candidateID });
    }
    else {
        log('commercial', `🛡️ Admiral - Event is not of expected format of candidate.shown ${JSON.stringify(event)}`);
    }
};
const handleCandidateDismissedEvent = (event) => {
    const isCandidateDismissedEvent = (e) => typeof e === 'object' && 'candidateID' in e && 'candidateGroups' in e;
    if (isCandidateDismissedEvent(event)) {
        log('commercial', `🛡️ Admiral - Candidate ${event.candidateID} was dismissed`);
        recordAdmiralOphanEvent({ action: 'CLOSE', value: event.candidateID });
    }
    else {
        log('commercial', `🛡️ Admiral - Event is not of expected format of candidate.dismissed ${JSON.stringify(event)}`);
    }
};
const setUpAdmiralEventLogger = (admiral) => {
    admiral('after', 'measure.detected', function (event) {
        handleMeasureDetectedEvent(event);
    });
    admiral('after', 'candidate.shown', function (event) {
        handleCandidateShownEvent(event);
    });
    admiral('after', 'candidate.dismissed', function (event) {
        handleCandidateDismissedEvent(event);
    });
};
/**
 * Admiral Adblock Recovery Init
 *
 * The script is loaded conditionally as a third-party-tag
 * @see /bundle/src/init/consented/third-party-tags.ts
 *
 * This function ensures admiral is available on the window object
 * and sets up Admiral event logging
 */
const initAdmiralAdblockRecovery = () => {
    // Set up window.admiral
    /* eslint-disable -- This is a stub provided by Admiral */
    window.admiral =
        window.admiral ||
            function () {
                // @ts-expect-error
                (admiral.q = admiral.q || []).push(arguments);
            };
    /* eslint-enable */
    void setUpAdmiralEventLogger(window.admiral);
    return Promise.resolve();
};
export { initAdmiralAdblockRecovery };
